import { scaleCorrectors as i } from "./atoms-v2928.js";
import { transformProps as n } from "./atoms-v2932.js";
function c(r, { layout: o, layoutId: t }) {
  return n.has(r) || r.startsWith("origin") || (o || t !== void 0) && (!!i[r] || r === "opacity");
}
export {
  c as isForcedMotionValue
};
